import { useNavigate } from 'react-router-dom';

function Feature3Home() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/academic-apply');
  };

  return (
    <section>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '1rem',
        }}
      >
        <div>
          <h3 className="pb-2 custom-home-h3 gradient-color">Dedicated to supporting academic research</h3>
          <h6 className="pb-2 mobile-responsive">
            Are you a student, academic or not-for-profit researcher who wants to access the latest biomedical
            data?
          </h6>
          <h6 className="mobile-responsive">
            Unlock the full potential of your research with DISGENET's dedicated academic plans.
          </h6>
          <div className="box-home-div"></div>
          <button className="btn-gradient-pink" onClick={handleClick}>
            APPLY NOW
          </button>
        </div>
        <div>
          <img src="../../../static/images/dis-Institutions.png" />
          <h6 style={{ color: 'rgb(154,159,170)' }}>
            DISGENET is built by researchers from academic institutions
          </h6>
        </div>
      </div>
    </section>
  );
}

export default Feature3Home;
